
import React from 'react';
import { Settings, Shield } from 'lucide-react';
import AdminPasswordChangeForm from '@/components/admin/dashboard/AdminPasswordChangeForm';

const AdminSettingsTab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center mb-6">
        <Settings className="h-5 w-5 mr-2 text-itmgmt-blue" />
        <h2 className="text-xl font-semibold">Admin Settings</h2>
      </div>
      
      <div className="bg-amber-50 border border-amber-200 rounded-md p-4 mb-6">
        <div className="flex items-start">
          <Shield className="h-5 w-5 text-amber-600 mt-0.5 mr-2 flex-shrink-0" />
          <div>
            <h3 className="font-medium text-amber-800">Security Recommendations</h3>
            <ul className="mt-2 text-sm text-amber-700 space-y-1">
              <li>• Change your password regularly (every 30-90 days)</li>
              <li>• Never share your credentials with others</li>
              <li>• Use a unique password that isn't used for other accounts</li>
              <li>• Enable two-factor authentication when available</li>
              <li>• Log out when using shared computers</li>
            </ul>
          </div>
        </div>
      </div>
      
      <AdminPasswordChangeForm />
    </div>
  );
};

export default AdminSettingsTab;
